import React from 'react';

function PreviousPage(props) {
  return(
    <a className="pagination-previous" onClick={props.onClick}>Previous</a>
  );
}

export default PreviousPage;
